import classNames from 'classnames'
import styles from './SmallProducerCard.module.scss'
import { SmallCardProps } from 'components/small-producer-card/types'
import { Heading } from '@boltenergy-be/design-system'
import ProducerLocation from 'components/producer-location/ProducerLocation.tsx'
import parse from 'html-react-parser'

const SmallProducerCard = ({ className, title, inverted, energyType, location }: SmallCardProps) => {
  return (
    <div className={classNames(styles.card, { [styles.inverted]: inverted }, className)}>
      {energyType && <ProducerLocation energyType={energyType} location={location} />}
      {title && (
        <Heading as="h3" variant="h6" className={inverted ? 'mb-200' : 'mt-200'}>
          {parse(title)}
        </Heading>
      )}
    </div>
  )
}

export default SmallProducerCard
